// import { Box, Container, Grid, TextField, Typography } from "@mui/material";
// import { useFormik } from "formik";
// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import * as Yup from "yup";
// import lodash from "lodash";
// import CustomCheckbox from "../../../../components/ui/CustomCheckbox";
// import NavigationButtons from "../NavigationButtons";
// import {
//   checkboxContainer,
//   contentContainer,
//   formContainer,
//   formStyle,
//   gridContainer,
//   headingText,
//   rootContainer,
//   sectionContainer,
//   standardText,
//   subtitleText,
//   textFieldStyles,
// } from "./SpecificationsSx";
// import FieldErrorText from "../../../../components/ui/FieldErrorText";
// import {
//   setActiveStep,
//   setMyGarageMultipleFields,
//   setSpecificationsForm,
// } from "../../../../toolkit/myGarage/myGarageSlice";
// import { MyGarageSteps } from "../../../../utils/constants/myGarage";
// import { setAlertDialog } from "../../../../toolkit/alertDialog/alertDialogSlice";
// import { useLazyUpdateCarQuery } from "../../../../toolkit/myGarage/myGarageApi";
// import { emptyFieldsPartialForm } from "./utils/emptyFieldsPartialForm";
// import { backendMappedValuesStep1 } from "./GeneralInfo";
// import { errorContainer } from "./QuestionareSx";

// const Specifications = ({ previousFormHandler }) => {
//   const features = [
//     { name: "leatherSeat", label: "Leather Seat", value: "LEATHER SEAT" },
//     { name: "heatedSeat", label: "Heated Seat", value: "HEATED SEAT" },
//     {
//       name: "heatedSteering",
//       label: "Heated Steering Wheel",
//       value: "HEATED STEERING WHEEL",
//     },
//     { name: "navigation", label: "Navigation", value: "NAVIGATION" },
//     { name: "alloyWheels", label: "Alloy Rims", value: "ALLOY RIMS" },
//     { name: "bluetooth", label: "Bluetooth", value: "BLUETOOTH" },
//     { name: "carplay", label: "Carplay", value: "CARPLAY" },
//     { name: "reverseCamera", label: "Reverse Camera", value: "REVERSE CAMERA" },
//     { name: "sunroof", label: "Sunroof", value: "SUNROOF" },
//     { name: "panoramicRoof", label: "Panoramic Roof", value: "PANORAMIC ROOF" },
//     { name: "powerSeats", label: "Power Seats", value: "POWER SEATS" },
//   ];

//   const registration = [
//     { name: "MTO_Irreparable", label: "Irreparable", value: "MTO_Irreparable" },
//     { name: "MTO_Rebuilt", label: "Rebuilt", value: "MTO_Rebuilt" },
//     { name: "MTO_Salvage", label: "Salvage", value: "MTO_Salvage" },
//     { name: "MTO_None", label: "None", value: "MTO_None" },
//   ];

//   // useRef start...
//   const onMountRef = React.useRef({
//     registration: false,
//     setSpecificationsForm: false
//   });
//   // useRef end...

//   // useSelector start...
//   const auth = useSelector((store) => store.auth);
//   // useSelector end...

//   const [updateCarApiHandler, updateCarApiData] = useLazyUpdateCarQuery();

//   const validationSchema = Yup.object({
//     Car_Condition: Yup.string()
//       .max(500),
//     registration: Yup.object().shape(
//       Object.fromEntries(
//         registration.map(({ value }) => [value, Yup.boolean()])
//       )
//     )
//     .test(
//       'at-least-one-true', // Name of the test
//       'Please select at least one registration option.', // Error message if the test fails
//       function (currentRegistrationObj) { // Renamed 'obj' to 'currentRegistrationObj' for clarity
//         // 'currentRegistrationObj' is the value of the 'registration' object being validated
//         // This is the MOST RELIABLE source for the current 'registration' state
//         if (!currentRegistrationObj) {
//           // If the object itself is null/undefined, it's not valid
//           return false;
//         }

//         // Convert the object values to an array and check if any are true
//         const values = Object.values(currentRegistrationObj);
//         const hasAtLeastOneTrue = values.some(val => val === true);

//         console.log(
//           "--- Inside 'at-least-one-true' test ---"
//         );
//         console.log('Values from currentRegistrationObj:', values);
//         console.log('Has at least one true:', hasAtLeastOneTrue);
//         console.log('Object entries:', Object.entries(currentRegistrationObj));
//         console.log('Current registration object (obj):', currentRegistrationObj);
//         console.log('Parent context (this.parent):', this.parent); // For observation, but not for direct value
//         console.log('------------------------------------');

//         // Return true if at least one value is true, false otherwise
//         console.log(hasAtLeastOneTrue, `hasAtLeastOneTrue`)
//         return hasAtLeastOneTrue;
//       }
//     ),
//     Car_Notes: Yup.string()
//       .max(500)
//   });

//   const initialValues = {
//     Car_Condition: "Good",
//     features: Object.fromEntries(features?.map(({ value }) => [value, false])),
//     registration: Object.fromEntries(
//       registration.map(({ value }) => [value, false])
//     ),
//     Car_Notes: "",
//   };

//   const dispatch = useDispatch();
//   const { forms, previouslySubmittedForms, vehicle_id } = useSelector(
//     (store) => store.myGarage
//   );

//   const generalInfoForm = forms?.generalInfo;
//   const questionareForm = forms?.questionare;
//   const specificationsForm = forms?.specifications;
//   const galleryForm = forms?.gallery;

//   const formik = useFormik({
//     initialValues,
//     validationSchema,
//     onSubmit: async (values) => {
//       const payload = {};
//       const formData = new FormData();

//       const { features, registration, ...valuesRest } = { ...values };

//       // for (let i = 0; i < Object.entries(emptyFieldsPartialForm)?.length; i++) {
//       //   payload[[Object.entries(emptyFieldsPartialForm)?.[i]?.[0]]] =
//       //     Object.entries(emptyFieldsPartialForm)?.[i]?.[1];
//       // }

//       const selectedFeatures = Object.keys(features).filter(
//         (key) => features?.[key]
//       );
//       payload["Additional_Car_Feature"] = selectedFeatures?.join(", ");

//       for (let i = 0; i < Object.entries(registration)?.length; i++) {
//         payload[Object.entries(registration)?.[i]?.[0]] = Object.entries(
//           registration
//         )?.[i]?.[1]
//           ? 1
//           : 0;
//       }

//       for (let i = 0; i < Object.entries(valuesRest)?.length; i++) {
//         payload[Object.entries(valuesRest)?.[i]?.[0]] =
//           Object.entries(valuesRest)?.[i]?.[1];
//       }

//       for (let i = 0; i < Object.entries(payload)?.length; i++) {
//         // payload[Object.entries(payload)?.[i]?.[0]] =
//         //   Object.entries(payload)?.[i]?.[1];
//         formData.append(
//           Object.entries(payload)?.[i]?.[0],
//           Object.entries(payload)?.[i]?.[1]
//         );
//       }

//       formData.append(`Seller_Id`, auth?.user_id);

//       if (
//         !lodash?.isEqual(
//           previouslySubmittedForms?.specifications,
//           formik?.values
//         )
//       ) {
//         const updateCarResponse = await updateCarApiHandler({
//           formData,
//           endpoint: `/updatevehicle/${vehicle_id}/normaledit`,
//         });

//         if (updateCarResponse?.isSuccess) {
//           dispatch(
//             setMyGarageMultipleFields({
//               previouslySubmittedForms: {
//                 ...previouslySubmittedForms,
//                 specifications: formik?.values,
//               },
//               forms: {
//                 ...previouslySubmittedForms,
//                 specifications: formik?.values,
//               },
//             })
//           );
//           // dispatch(setSpecificationsForm(values));
//           dispatch(setActiveStep(MyGarageSteps[3]));
//         } else {
//           dispatch(
//             setAlertDialog({
//               open: true,
//               title: `Error!`,
//               message:
//                 updateCarResponse?.error?.message || "Some error occured!",
//             })
//           );
//         }
//       } else {
//         dispatch(setActiveStep(MyGarageSteps[3]));
//       }
//     },
//   });

//   React.useEffect(() => {
//     if (forms?.specifications) {
//       formik.setValues(forms?.specifications);
//     }
//   }, []);

//   React.useEffect(() => {
//     if (onMountRef.current.setSpecificationsForm) {
//       dispatch(setSpecificationsForm(formik?.values));
//     } else {
//       onMountRef.current.setSpecificationsForm = true;
//     }
//   }, [formik?.values]);

//   React.useEffect(() => {
//     if (onMountRef.current?.registration) {
//       formik.setTouched({
//         ...formik.touched,
//         registration: true
//       });
//     } else {
//       onMountRef.current.registration = true;
//     }

//   }, [formik?.values?.registration]);

//   console.log(`Specifications`, formik, validationSchema)

//   return (
//     <Box sx={rootContainer}>
//       <Box sx={contentContainer}>
//         <Container sx={formContainer}>
//           <form style={formStyle} onSubmit={formik.handleSubmit}>
//             <Box sx={sectionContainer}>
//               <Typography sx={standardText}>
//                 Select the best option that describes the condition of the car.
//               </Typography>
//               <Box sx={checkboxContainer}>
//                 {["Awesome", "Good", "Okay", "Rough"].map((option) => (
//                   <CustomCheckbox
//                     key={option}
//                     label={option}
//                     selected={formik.values.Car_Condition === option}
//                     onClick={() =>
//                       formik.setFieldValue("Car_Condition", option)
//                     }
//                   />
//                 ))}
//               </Box>
//             </Box>

//             <Box sx={sectionContainer}>
//               <Typography sx={standardText}>
//                 Additional car features.
//               </Typography>
//               <Grid container sx={gridContainer} spacing={2}>
//                 {features?.map((feature) => (
//                   <CustomCheckbox
//                     key={feature?.name}
//                     label={feature?.label}
//                     selected={formik.values.features?.[feature.value]}
//                     onClick={() =>
//                       formik.setFieldValue(
//                         `features.${feature?.value}`,
//                         !formik.values.features?.[feature.value]
//                       )
//                     }
//                   />
//                 ))}
//               </Grid>
//             </Box>

//             <Box sx={sectionContainer}>
//               <Typography sx={standardText}>MTO Registration Brand <span style={{ color: "red" }}>*</span></Typography>
//               <Box sx={checkboxContainer}>
//                 {registration.map((reg) => (
//                   <CustomCheckbox
//                     key={reg.name}
//                     label={reg.label}
//                     selected={formik.values.registration[reg.value]}
//                     onClick={() => {
//                       formik.setFieldValue(
//                         `registration.${reg.value}`,
//                         !formik.values.registration[reg.value]
//                       );
//                     }}
//                   />
//                 ))}
//               </Box>

//               {formik?.touched?.registration && formik?.errors?.registration && (
//                 <Box sx={{
//                   ...errorContainer,
//                   justifyContent: "flex-start"
//                 }}>
//                   <FieldErrorText>{formik?.errors?.registration}</FieldErrorText>
//                 </Box>
//               )}
//             </Box>

//             <Box sx={sectionContainer}>
//               <Typography sx={headingText}>Just some more details</Typography>
//               <Typography sx={standardText}>
//                 Help Us Know Your Car Better!
//               </Typography>
//               <Typography variant="subtitle1" sx={subtitleText}>
//                 Note
//               </Typography>
//               <TextField
//                 sx={textFieldStyles}
//                 multiline={true}
//                 rows={4}
//                 variant="outlined"
//                 placeholder="Write a detailed description of your car."
//                 value={formik.values.Car_Notes}
//                 onChange={(e) =>
//                   formik.setFieldValue("Car_Notes", e.target.value)
//                 }
//               />

//               {formik.touched.Car_Notes && formik.errors.Car_Notes && (
//                 <FieldErrorText>{formik.errors.Car_Notes}</FieldErrorText>
//               )}
//             </Box>

//             <NavigationButtons
//               onSubmit={formik.handleSubmit}
//               isLoading={updateCarApiData?.isFetching}
//               previousFormHandler={previousFormHandler}
//             />
//           </form>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Specifications;

import { Box, Container, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useFormik } from 'formik';
import lodash from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import CustomCheckbox from '../../../../components/ui/CustomCheckbox';
import FieldErrorText from '../../../../components/ui/FieldErrorText';
import { setAlertDialog } from '../../../../toolkit/alertDialog/alertDialogSlice';
import { useLazyGetVehicleDetailsQuery } from '../../../../toolkit/carDetails/carDetailsApi';
import { useLazyUpdateCarQuery, useUpdateCarOnRelistPendingMutation } from '../../../../toolkit/myGarage/myGarageApi';
import {
  setActiveStep,
  setMyGarageMultipleFields,
  setSpecificationsForm,
} from '../../../../toolkit/myGarage/myGarageSlice';
import { CAR_STATUS } from '../../../../utils/constants/carData';
import { MyGarageSteps } from '../../../../utils/constants/myGarage';
import { isVehicleDataEditEnabled } from '../../../../utils/methods/generalVehicleMethods';
import NavigationButtons from '../NavigationButtons';
import { errorContainer } from './QuestionareSx';
import {
  contentContainer,
  formContainer,
  formStyle,
  headingText,
  rootContainer,
  sectionContainer,
  standardText,
  subtitleText,
  textFieldStyles
} from './SpecificationsSx';

const Specifications = ({ previousFormHandler }) => {
  const { t } = useTranslation('specification');

  const features = [
    { name: 'leatherSeat', label: t('features.leatherSeat'), value: 'LEATHER SEAT' },
    { name: 'heatedSeat', label: t('features.heatedSeat'), value: 'HEATED SEAT' },
    {
      name: 'heatedSteering',
      label: t('features.heatedSteering'),
      value: 'HEATED STEERING WHEEL',
    },
    { name: 'navigation', label: t('features.navigation'), value: 'NAVIGATION' },
    { name: 'alloyWheels', label: t('features.alloyWheels'), value: 'ALLOY RIMS' },
    { name: 'bluetooth', label: t('features.bluetooth'), value: 'BLUETOOTH' },
    { name: 'carplay', label: t('features.carplay'), value: 'CARPLAY' },
    { name: 'reverseCamera', label: t('features.reverseCamera'), value: 'REVERSE CAMERA' },
    { name: 'sunroof', label: t('features.sunroof'), value: 'SUNROOF' },
    { name: 'panoramicRoof', label: t('features.panoramicRoof'), value: 'PANORAMIC ROOF' },
    { name: 'powerSeats', label: t('features.powerSeats'), value: 'POWER SEATS' },
  ];

  const registration = [
    { name: 'MTO_Irreparable', label: t('registration.irreparable'), value: 'MTO_Irreparable' },
    { name: 'MTO_Rebuilt', label: t('registration.rebuilt'), value: 'MTO_Rebuilt' },
    { name: 'MTO_Salvage', label: t('registration.salvage'), value: 'MTO_Salvage' },
    { name: 'MTO_None', label: t('registration.none'), value: 'MTO_None' },
  ];

  const conditionOptions = [
    { key: 'awesome', label: t('conditionOptions.awesome'), value: 'Awesome' },
    { key: 'good', label: t('conditionOptions.good'), value: 'Good' },
    { key: 'okay', label: t('conditionOptions.okay'), value: 'Okay' },
    { key: 'rough', label: t('conditionOptions.rough'), value: 'Rough' },
  ];

  // useRef start...
  const onMountRef = React.useRef({
    registration: false,
    setSpecificationsForm: false,
  });
  // useRef end...

  // useSelector start...
  const auth = useSelector((store) => store.auth);
  const { forms, previouslySubmittedForms, vehicle_id, selectedVehicle } = useSelector((store) => store.myGarage);
  // useSelector end...

  const [updateCarApiHandler, updateCarApiData] = useLazyUpdateCarQuery();
  const [updateCarOnRelistPendingApiHandler, updateCarOnRelistPendingApiData] = useUpdateCarOnRelistPendingMutation();
  const [getVehicleDetailsApiHandler, getVehicleDetailsApiData] = useLazyGetVehicleDetailsQuery();

  const validationSchema = Yup.object({
    Car_Condition: Yup.string().max(500),
    registration: Yup.object()
      .shape(
        Object.fromEntries(
          registration.map(({ value }) => [value, Yup.boolean()])
        )
      )
      .test(
        'exactly-one-true', 
        t('registrationError'), 
        function (currentRegistrationObj) {
          if (!currentRegistrationObj) return false;

          // Count how many keys have the value 'true'
          const selectedCount = Object.values(currentRegistrationObj)
            .filter((val) => val === true).length;

          // Returns true only if exactly one option is selected
          return selectedCount === 1;
        }
      ),
    Car_Notes: Yup.string().max(500),
  });

  const initialValues = {
    Car_Condition: 'Good',
    features: Object.fromEntries(features?.map(({ value }) => [value, false])),
    registration: Object.fromEntries(registration.map(({ value }) => [value, false])),
    Car_Notes: '',
  };

  const dispatch = useDispatch();

  const generalInfoForm = forms?.generalInfo;
  const questionareForm = forms?.questionare;
  const specificationsForm = forms?.specifications;
  const galleryForm = forms?.gallery;

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const payload = {};
      const formData = new FormData();

      const { features, registration, ...valuesRest } = { ...values };

      // for (let i = 0; i < Object.entries(emptyFieldsPartialForm)?.length; i++) {
      //   payload[[Object.entries(emptyFieldsPartialForm)?.[i]?.[0]]] =
      //     Object.entries(emptyFieldsPartialForm)?.[i]?.[1];
      // }

      const selectedFeatures = Object.keys(features).filter((key) => features?.[key]);
      payload['Additional_Car_Feature'] = selectedFeatures?.join(', ');

      for (let i = 0; i < Object.entries(registration)?.length; i++) {
        payload[Object.entries(registration)?.[i]?.[0]] = Object.entries(registration)?.[i]?.[1] ? 1 : 0;
      }

      for (let i = 0; i < Object.entries(valuesRest)?.length; i++) {
        payload[Object.entries(valuesRest)?.[i]?.[0]] = Object.entries(valuesRest)?.[i]?.[1];
      }

      for (let i = 0; i < Object.entries(payload)?.length; i++) {
        // payload[Object.entries(payload)?.[i]?.[0]] =
        //   Object.entries(payload)?.[i]?.[1];
        formData.append(Object.entries(payload)?.[i]?.[0], Object.entries(payload)?.[i]?.[1]);
      }

      formData.append(`Seller_Id`, auth?.user_id);

      if (!lodash?.isEqual(previouslySubmittedForms?.specifications, formik?.values)) {
        let updateCarResponse;

        if (getVehicleDetailsApiData?.data?.vehicle?.car_label_status === CAR_STATUS.RELIST_PENDING) {
          updateCarResponse = await updateCarOnRelistPendingApiHandler({
            formData,
            Vehicle_Id: vehicle_id,
          });
        } else {
          updateCarResponse = await updateCarApiHandler({
            formData,
            endpoint: `/updatevehicle/${vehicle_id}/normaledit`,
          });
        }

        if (
          updateCarResponse?.isSuccess ||
          ('status' in (updateCarResponse?.data || {}) && updateCarResponse?.data?.status)
        ) {
          dispatch(
            setMyGarageMultipleFields({
              previouslySubmittedForms: {
                ...previouslySubmittedForms,
                specifications: formik?.values,
              },
              forms: {
                ...previouslySubmittedForms,
                specifications: formik?.values,
              },
            })
          );
          // dispatch(setSpecificationsForm(values));
          dispatch(setActiveStep(MyGarageSteps[3]));
        } else {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error!`,
              message: updateCarResponse?.error?.message || 'Some error occured!',
            })
          );
        }
      } else {
        dispatch(setActiveStep(MyGarageSteps[3]));
      }
    },
  });

  React.useEffect(() => {
    if (forms?.specifications) {
      formik.setValues(forms?.specifications);
    }
  }, []);

  React.useEffect(() => {
    if (onMountRef.current.setSpecificationsForm) {
      dispatch(setSpecificationsForm(formik?.values));
    } else {
      onMountRef.current.setSpecificationsForm = true;
    }
  }, [formik?.values]);

  React.useEffect(() => {
    if (onMountRef.current?.registration) {
      formik.setTouched({
        ...formik.touched,
        registration: true,
      });
    } else {
      onMountRef.current.registration = true;
    }
  }, [formik?.values?.registration]);

  React.useEffect(() => {
    if (!vehicle_id) {
      return;
    }

    (async () => {
      await getVehicleDetailsApiHandler({
        vehicleId: vehicle_id,
      });
    })();
  }, [vehicle_id]);

  console.log(`Specifications`, formik, validationSchema);

  return (
    <Box sx={rootContainer}>
      <Box sx={contentContainer}>
        <Container sx={formContainer}>
          <form style={formStyle} onSubmit={formik.handleSubmit}>
            <Box sx={sectionContainer}>
              <Typography sx={standardText}>{t('carConditionTitle')}</Typography>
              <Grid container spacing={1}>
                {conditionOptions.map((option) => (
                  <Grid item size={{ xs: 12, sm: 'auto', md: 'auto', lg: 'auto' }} key={option.key}>
                    <CustomCheckbox
                      fullWidth
                      label={option.label}
                      selected={formik.values.Car_Condition === option.value}
                      onClick={() => formik.setFieldValue('Car_Condition', option.value)}
                      disabled={
                        !isVehicleDataEditEnabled({
                          car: selectedVehicle,
                        })
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box sx={sectionContainer}>
              <Typography sx={standardText}>{t('additionalFeaturesTitle')}</Typography>
              <Grid container spacing={1}>
                {features?.map((feature) => (
                  <Grid item size={{ xs: 12, sm: 'auto', md: 'auto', lg: 'auto' }} key={feature?.name}>
                    <CustomCheckbox
                      fullWidth
                      label={feature?.label}
                      selected={formik.values.features?.[feature.value]}
                      onClick={() =>
                        formik.setFieldValue(`features.${feature?.value}`, !formik.values.features?.[feature.value])
                      }
                      disabled={
                        !isVehicleDataEditEnabled({
                          car: selectedVehicle,
                        })
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box sx={sectionContainer}>
              <Typography sx={standardText}>
                {t('mtoRegistrationTitle')} <span style={{ color: 'red' }}>{t('required')}</span>
              </Typography>
              <Grid container spacing={1}>
                {registration.map((reg) => (
                  <Grid item size={{ xs: 12, sm: 'auto', md: 'auto', lg: 'auto' }} key={reg.name}>
                    <CustomCheckbox
                      fullWidth
                      label={reg.label}
                      selected={formik.values.registration[reg.value]}
                      onClick={() => {
                        formik.setFieldValue(`registration.${reg.value}`, !formik.values.registration[reg.value]);
                      }}
                      disabled={
                        !isVehicleDataEditEnabled({
                          car: selectedVehicle,
                        })
                      }
                    />
                  </Grid>
                ))}
              </Grid>

              {formik?.touched?.registration && formik?.errors?.registration && (
                <Box
                  sx={{
                    ...errorContainer,
                    justifyContent: 'flex-start',
                  }}
                >
                  <FieldErrorText>{formik?.errors?.registration}</FieldErrorText>
                </Box>
              )}
            </Box>

            <Box sx={sectionContainer}>
              <Typography sx={headingText}>{t('moreDetailsTitle')}</Typography>
              <Typography sx={standardText}>{t('moreDetailsSubtitle')}</Typography>
              <Typography variant="subtitle1" sx={subtitleText}>
                {t('noteLabel')}
              </Typography>
              <TextField
                sx={textFieldStyles}
                multiline={true}
                rows={4}
                variant="outlined"
                placeholder={t('notePlaceholder')}
                value={formik.values.Car_Notes}
                onChange={(e) => formik.setFieldValue('Car_Notes', e.target.value)}
                disabled={
                  !isVehicleDataEditEnabled({
                    car: selectedVehicle,
                  })
                }
              />

              {formik.touched.Car_Notes && formik.errors.Car_Notes && (
                <FieldErrorText>{formik.errors.Car_Notes}</FieldErrorText>
              )}
            </Box>

            <NavigationButtons
              onSubmit={formik.handleSubmit}
              isLoading={updateCarApiData?.isFetching || updateCarOnRelistPendingApiData?.isLoading}
              previousFormHandler={previousFormHandler}
            />
          </form>
        </Container>
      </Box>
    </Box>
  );
};

export default Specifications;
